import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import Alert, { showLoading, toast } from "view/component/Alert";
import Form from "../component/Form"
import ApiService from "../../apiService";
import FormValidator from "../component/formValidator";
import moment from "moment";

const ModalChangeRoom = ({refDpjp, refRoom, ...props}) => {

  const [dpjpId, setDpjpId] = useState('')
  const [roomId, setRoomId] = useState('')
  const [disableButton, setDisableButton] = useState(false)

  const formOnSubmitHandler = async (event) => {
    event.preventDefault();

    const param = {
      inpatient_id: props.data.inpatient.id,
      dpjp_id: dpjpId,
      room_id: roomId,
      entry_date: moment().format('YYYY-MM-DD')
    }

    setDisableButton(true)
    const res = await ApiService.post("registration/inpatient/create_room", param);
    if (res.code === 200) {
      setDisableButton(false)
      Alert("success", "Pendaftaran Sukses");
      props.reloadData()
    }
    else {
      Alert("error", res.status);
      setDisableButton(false)
    }
  }

  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} aria-labelledby="modal-user">
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Pindah Ruangan</h3>
          </ModalTitle>
        </ModalHeader>
        <Form wasValidated={true} validationRules={new FormValidator([])}>
          <ModalBody>
            <Form.Select
                label={"Ruangan"}
                value={roomId}
                name="room_id"
                options={refRoom}
                onChange={e => setRoomId(e.target.value)}
            />
            <Form.Select
                label={"Dokter DPJP"}
                value={dpjpId}
                name="dpjp_id"
                options={refDpjp}
                onChange={e => setDpjpId(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              onClick={() => {
                props.onHide();
              }}
              className="btn btn-secondary"
            >
              Batal
            </button>
            <button
                disabled={disableButton}
                onClick={(event) => formOnSubmitHandler(event)}
                className="btn btn-primary"
            >
              Simpan Data
            </button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalChangeRoom;
